import DownloadExcel from './DownloadExcel';
import RollingDownload from './RollingDownloadResult';

export const RollingDownloadResult = RollingDownload;

export default DownloadExcel;